export default __webpack_public_path__ + "static/media/bg-paper-white-mob.e1cd5334.png";